import React from 'react';
import { Box, Card, Typography } from '@mui/material';
import { PieChart, Pie, Cell, ResponsiveContainer, Label, Tooltip } from 'recharts';

export default function CampaignDonut({ active, inActive, total, ir, or }) {
  const data = [
    { name: 'Active', value: active, gradient: 'url(#assignedGradient)', color: '#054EEE' },
    { name: 'In-Active', value: inActive, gradient: 'url(#unassignedGradient)', color: '#FF3C00' }
  ];

  // --- Tooltip bubble ---
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            background: '#fff',
            padding: '6px 10px',
            borderRadius: 12,
            fontSize: 14,
            fontWeight: 700,
            color: payload[0].payload.color,
            boxShadow: '0px 2px 6px rgba(0,0,0,0.15)'
          }}
        >
          {payload[0].value}
        </div>
      );
    }
    return null;
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          display: 'inline-block',
          px: 2.5,
          py: 1,
          borderRadius: 1,
          mb: 0.8,
          backgroundColor: '#F6F9FF',
          boxShadow: '0px 4px 12px rgba(0,0,0,0.08)'
        }}
      >
        <Typography sx={{ fontWeight: 700, fontSize: '14px', lineHeight: '14px' }}>
          Campaign Stats
        </Typography>
      </Box>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: or * 2 + 5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Tooltip content={<CustomTooltip />} cursor={false} />

            <Pie data={data} innerRadius={ir} outerRadius={or} dataKey="value" nameKey="name">
              {data.map((entry, idx) => (
                <Cell key={idx} fill={entry.gradient} />
              ))}

              <Label
                position="center"
                content={() => (
                  <text
                    x="50%"
                    y="42%"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    style={{
                      fontSize: '25px',
                      fontWeight: 700,
                      fill: '#171D40',
                      fontFamily: 'Montserrat'
                    }}
                  >
                    {total}

                    <tspan
                      x="50%"
                      dy="20"
                      style={{ fontSize: 10, fill: '#171D40', fontWeight: 600 }}
                    >
                      Total
                    </tspan>

                    <tspan
                      x="50%"
                      dy="11"
                      style={{ fontSize: 10, fill: '#171D40', fontWeight: 600 }}
                    >
                      Campaigns
                    </tspan>
                  </text>
                )}
              />
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </Box>
      {/* Legend */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          columnGap: 0,
          mt: 1
        }}
      >
        {data.map((item, i) => (
          <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <svg width="5" height="5" viewBox="0 0 8 8">
              <circle cx="4" cy="4" r="4" fill={item.color} />
            </svg>
            <Typography sx={{ fontSize: 11, fontWeight: 700, color: '#171D40' }}>
              {item.name}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
